import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from 'recharts';
import { FunctionComponent } from 'react';

const chartData = [
    {
        name: 'Early Morning',
        time: '5am-8am',
        count: 3537
    },
    {
        name: 'Morning',
        time: '8am-11am',
        count: 3383
    },
    {
        name: 'Lunch',
        time: '11am-12pm',
        count: 2537
    },
    {
        name: 'Afternoon',
        time: '12pm-5pm',
        count: 1237
    },
    {
        name: 'Evening',
        time: '5pm-12am',
        count: 220
    }
];

const COLORS = ['#21539B', '#A0D5FF', '#218FE6', '#69A7D8', '#7B8491'];
const RADIAN = Math.PI / 180;


type CircleLegendProps = {
    label: string,
    color: string,
    count: string
}

const CircleLegend: FunctionComponent<CircleLegendProps> = ({ label, color, count }) => {
    return (
        <Stack direction="column" sx={{ alignItems: 'left' }} spacing={1}>
            <Stack direction="row" sx={{
                padding: '2px 10px 2px 10px',
            }}>
                <Box sx={{
                    width: 24,
                    borderRadius: '50%',
                    height: 20,
                    backgroundColor: color,
                    padding: '0 0 0 0',
                }}>&nbsp;
                </Box>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%'
                }}>
                    <Typography sx={{
                        padding: '0px 10px 10px 15px',
                        color: 'text.primary',
                        fontFamily: 'Montserrat'
                    }}>
                        {label}
                    </Typography>
                    <Typography sx={{
                        padding: '0px 10px 10px 25px',
                        color: 'text.primary',
                        fontFamily: 'Montserrat'
                    }}>
                        {count}
                    </Typography>
                </Box>
            </Stack>
        </Stack>
    )
}


const renderCustomizedLabel = (data: { cx: number, cy: number, midAngle: number, innerRadius: number, outerRadius: number, percent: number, index: number }) => {

    const radius = data.innerRadius + (data.outerRadius - data.innerRadius) * 0.5;
    const x = data.cx + radius * Math.cos(-data.midAngle * RADIAN);
    const y = data.cy + radius * Math.sin(-data.midAngle * RADIAN);

    return (
        <text x={x} y={y} fill="white" textAnchor='middle' dominantBaseline="central" fontSize={14} >
            {`${(data.percent * 100).toFixed(0)}%`}
        </text>
    );
};

export interface TimeOfDayData {
    name: string;
    time: string;
    count: number;
}

interface TimeOfDayPieChartProps {
    data: TimeOfDayData[];
}


export default function TimeOfDayPieChart(props: TimeOfDayPieChartProps) {

    const renderLegend = ( { payload }: any) => {

        return (
            <Stack spacing={2}>
                {
                    payload.map((entry: any, i: number) => {
                        const { payload: item } = entry;
                        return (
                            <CircleLegend key={i} label={item.name} color={COLORS[i % COLORS.length]} count={item.count} />
                        )
                    })
                }
            </Stack>
        )
    }

    return (
        <Stack sx={{
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            width: '80%'
        }}>
            <ResponsiveContainer >
                <PieChart  >
                    <Pie
                        data={chartData}
                        labelLine={false}
                        innerRadius={100}
                        dataKey="count"
                        cx='40%'
                        label={renderCustomizedLabel}

                    >
                        {chartData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} color='white' />
                        ))}
                    </Pie>
                    <Legend content={renderLegend} layout="vertical" verticalAlign="middle" align="right" />
                </PieChart>
            </ResponsiveContainer>
        </Stack>
    );
}